import {
  IBrand,
  IBrandPaymentMethodSettings,
} from '@principle-theorem/principle-core/interfaces';
import { DocumentReference, Firestore } from '@principle-theorem/shared';

export class KnowledgeBaseFeesPayments {
  static formatFeesPayments(settings?: IBrandPaymentMethodSettings): string {
    if (!settings) {
      return '';
    }

    const parts: string[] = [];

    const providers = uniqueNonEmpty(
      (settings.availableProviders ?? []).map(
        (provider) => provider.patientFriendlyName
      )
    );
    if (providers.length) {
      parts.push(`We accept ${formatList(providers)}.`);
    }

    const funds = uniqueNonEmpty(settings.insuranceFundsAccepted ?? []);
    if (funds.length) {
      parts.push(`We accept the following health funds: ${formatList(funds)}.`);
    }

    const programs = uniqueNonEmpty(settings.governmentPrograms ?? []);
    if (programs.length) {
      parts.push(`We support ${formatList(programs)}.`);
    }

    const paymentPlans = settings.paymentPlanDescriptions?.trim();
    if (paymentPlans) {
      parts.push(paymentPlans);
    }

    return parts.join(' ');
  }

  static async deriveFeesPayments(
    brandRef: DocumentReference<IBrand>
  ): Promise<string> {
    const brand = await Firestore.getDoc(brandRef);
    return KnowledgeBaseFeesPayments.formatFeesPayments(
      brand.settings.paymentMethods
    );
  }
}

function uniqueNonEmpty(values: (string | undefined)[]): string[] {
  const trimmed = values
    .map((value) => value?.trim())
    .filter((value): value is string => Boolean(value));
  return [...new Set(trimmed)];
}

function formatList(items: string[]): string {
  if (items.length <= 1) {
    return items[0] ?? '';
  }
  if (items.length === 2) {
    return `${items[0]} and ${items[1]}`;
  }
  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
}
